var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1861 1.90593C11.9029 0.362462 14.0971 0.362461 14.8139 1.90593L17.0643 6.75167C17.3557 7.37917 17.9508 7.81149 18.6376 7.89474L23.9416 8.53757C25.631 8.74233 26.3091 10.8292 25.0627 11.9879L21.1495 15.6255C20.6428 16.0966 20.4155 16.7961 20.5486 17.4751L21.5762 22.7181C21.9035 24.3881 20.1283 25.6779 18.6412 24.8505L13.9724 22.253C13.3678 21.9166 12.6322 21.9166 12.0276 22.253L7.35879 24.8505C5.87166 25.6779 4.09645 24.3881 4.42378 22.7181L5.45143 17.4751C5.58451 16.7961 5.35722 16.0966 4.85048 15.6255L0.937316 11.9879C-0.309104 10.8292 0.368966 8.74233 2.05839 8.53757L7.36237 7.89474C8.04922 7.81149 8.64426 7.37917 8.93567 6.75167L11.1861 1.90593Z",
    fill: "#FFCC6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.5e393e8066969e2ef9d8b6fae2926d09.svg";
export { ForwardRef as ReactComponent };